/*
 * EverQuilts - "2nd shirt ships free" upsell in the cart drawer (27.10.2026)
 * Loaded site-wide by snippets/wishlist-drawer.liquid (rendered once in
 * layout/theme.liquid). Styles: assets/eq-cart-upsell.css.
 *
 * When the drawer holds exactly 1 shirt, a box is added under the line item:
 *   "Add a 2nd shirt and shipping is FREE - you save $4.99."
 * with up to 4 related designs from Shopify's Product Recommendations API.
 * Each card adds the SAME Style / Color / Size as the shirt in the cart; a
 * design without that exact, available variant is skipped. With 2+ shirts
 * (or an empty cart) the box is not shown.
 * Must match the automatic discount "Free US Shipping on 2+ Shirts" and the
 * $4.99 Standard rate for a single shirt.
 *
 * Dawn rebuilds the drawer HTML on every cart change, so the box is
 * re-inserted by a MutationObserver. While the box is shown, the older
 * "Customer's Also Loved" row (assets/eq-cart-drawer.js) is hidden by CSS so
 * the drawer does not show two recommendation rows.
 */
(function () {
  'use strict';
  if (window.eqCartUpsell) return;
  window.eqCartUpsell = true;

  var HEADING = 'Add a 2nd shirt and shipping is FREE — you save $4.99.';
  var MAX_CARDS = 4;
  var FETCH_LIMIT = 10;
  var cache = {};

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function money(cents) {
    var v = cents;
    if (typeof v === 'string') v = v.indexOf('.') > -1 ? Math.round(parseFloat(v) * 100) : parseInt(v, 10);
    if (typeof v !== 'number' || isNaN(v)) return '';
    return '$' + (v / 100).toFixed(2);
  }

  function shortTitle(t) {
    t = String(t || '')
      .replace(/\s+(unisex\s+)?(t-?shirts?|tees?|shirts?|sweatshirts?)\s*$/i, '')
      .trim();
    if (t.length > 42) t = t.slice(0, 40).replace(/\s+\S*$/, '') + '…';
    return t;
  }

  function imageUrl(v, p) {
    var src = (v && v.featured_image && v.featured_image.src) || p.featured_image || (p.images && p.images[0]) || '';
    if (src && typeof src === 'object') src = src.src || '';
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=240';
  }

  function optionNames(p) {
    return (p.options || []).map(function (o) {
      return String(typeof o === 'string' ? o : o && o.name).toLowerCase();
    });
  }

  function variantOptions(v) {
    if (v.options && v.options.length) return v.options;
    return [v.option1, v.option2, v.option3].filter(function (x) {
      return x != null;
    });
  }

  /* --------------------------------------------------------- data */

  function getCart() {
    return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      if (!r.ok) throw new Error('cart ' + r.status);
      return r.json();
    });
  }

  function getCards(line) {
    var key = line.product_id + ':' + line.variant_id;
    if (cache[key]) return cache[key];

    var want = {};
    (line.options_with_values || []).forEach(function (o) {
      want[String(o.name).toLowerCase()] = o.value;
    });
    var wantCount = Object.keys(want).length;

    var p = fetch(
      root() + 'recommendations/products.json?product_id=' + line.product_id + '&limit=' + FETCH_LIMIT + '&intent=related'
    )
      .then(function (r) {
        if (!r.ok) throw new Error('recommendations ' + r.status);
        return r.json();
      })
      .then(function (data) {
        var cards = [];
        ((data && data.products) || []).forEach(function (prod) {
          if (cards.length >= MAX_CARDS || prod.id === line.product_id) return;
          var names = optionNames(prod);
          if (!wantCount || names.length !== wantCount) return;
          var match = null;
          (prod.variants || []).some(function (v) {
            if (!v.available) return false;
            var vals = variantOptions(v);
            var ok = names.every(function (n, i) {
              return want[n] != null && vals[i] === want[n];
            });
            if (ok) match = v;
            return ok;
          });
          if (!match) return;
          cards.push({
            id: match.id,
            title: shortTitle(prod.title),
            fullTitle: prod.title || '',
            url: (prod.url || root() + 'products/' + prod.handle) + '?variant=' + match.id,
            img: imageUrl(match, prod),
            price: money(match.price)
          });
        });
        return cards;
      })
      .catch(function (err) {
        delete cache[key];
        if (window.console) console.warn('[eq-cart-upsell] recommendations failed:', err);
        return [];
      });

    cache[key] = p;
    return p;
  }

  /* --------------------------------------------------------- render */

  function make(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function render(box, cards, line) {
    if (!cards.length) {
      box.remove();
      return;
    }
    box.textContent = '';
    box.appendChild(make('p', 'eq-upsell__heading', HEADING));

    var opts = (line.options_with_values || [])
      .map(function (o) {
        return o.value;
      })
      .join(' · ');
    if (opts) box.appendChild(make('p', 'eq-upsell__sub', 'Added in the same style, color and size: ' + opts));

    var row = make('div', 'eq-upsell__row');
    cards.forEach(function (c) {
      var card = make('div', 'eq-upsell__card');

      var media = make('a', 'eq-upsell__media');
      media.href = c.url;
      media.setAttribute('aria-label', c.fullTitle);
      if (c.img) {
        var img = document.createElement('img');
        img.src = c.img;
        img.alt = '';
        img.width = 240;
        img.height = 240;
        img.loading = 'lazy';
        media.appendChild(img);
      }
      card.appendChild(media);

      var title = make('a', 'eq-upsell__title', c.title);
      title.href = c.url;
      title.title = c.fullTitle;
      card.appendChild(title);

      card.appendChild(make('span', 'eq-upsell__price', c.price));

      var btn = make('button', 'eq-upsell__add', 'Add');
      btn.type = 'button';
      btn.dataset.variantId = c.id;
      btn.setAttribute('aria-label', 'Add ' + c.fullTitle + ' to cart');
      card.appendChild(btn);

      row.appendChild(card);
    });
    box.appendChild(row);
    box.hidden = false;
    var inner = box.closest('.drawer__inner');
    if (inner) inner.classList.add('eq-upsell-on');
  }

  /* --------------------------------------------------------- decorate */

  function shirtCount(inner) {
    var n = 0;
    inner.querySelectorAll('#CartDrawer-CartItems .quantity__input').forEach(function (input) {
      var q = parseInt(input.value, 10);
      if (!isNaN(q)) n += q;
    });
    return n;
  }

  function decorate() {
    var drawer = document.querySelector('cart-drawer');
    var inner = drawer && drawer.querySelector('.drawer__inner');
    if (!inner) return;
    var items = inner.querySelector('#CartDrawer-CartItems');
    var box = inner.querySelector('.eq-upsell');
    var empty = !items || !!inner.querySelector('.drawer__inner-empty');

    if (empty || shirtCount(inner) !== 1) {
      if (box) box.remove();
      inner.classList.remove('eq-upsell-on');
      return;
    }
    if (box) return;

    /* Dawn may keep .drawer__inner and only swap its HTML: reset our flag. */
    inner.classList.remove('eq-upsell-on');
    box = make('div', 'eq-upsell');
    box.hidden = true;
    var recs = items.querySelector('.eqcd-recs');
    if (recs) items.insertBefore(box, recs);
    else items.appendChild(box);

    getCart()
      .then(function (cart) {
        if (!box.isConnected) return;
        if (!cart || cart.item_count !== 1 || !cart.items || !cart.items[0]) {
          box.remove();
          return;
        }
        var line = cart.items[0];
        return getCards(line).then(function (cards) {
          if (box.isConnected) render(box, cards, line);
        });
      })
      .catch(function (err) {
        if (box.isConnected) box.remove();
        if (window.console) console.warn('[eq-cart-upsell]', err);
      });
  }

  /* --------------------------------------------------------- add */

  function add(btn) {
    var id = btn.dataset.variantId;
    if (!id || btn.disabled) return;
    var drawer = document.querySelector('cart-drawer');
    btn.disabled = true;
    btn.textContent = 'Adding…';

    var body = new FormData();
    body.append('id', id);
    body.append('quantity', '1');
    var sections = [];
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      sections = drawer.getSectionsToRender().map(function (s) {
        return s.id;
      });
    }
    if (sections.length) {
      body.append('sections', sections.join(','));
      body.append('sections_url', window.location.pathname);
    }

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (res) {
        if (res && res.status) {
          btn.textContent = 'Unavailable';
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'eq-cart-upsell', productVariantId: id, cartData: res });
        }
        if (drawer && typeof drawer.renderContents === 'function' && res && res.sections) {
          drawer.renderContents(res);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || root() + 'cart';
        }
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.textContent = 'Add';
        if (window.console) console.warn('[eq-cart-upsell] add failed:', err);
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.eq-upsell__add');
    if (!btn) return;
    e.preventDefault();
    add(btn);
  });

  /* --------------------------------------------------------- start */

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    setTimeout(function () {
      queued = false;
      decorate();
    }, 0);
  }

  function start() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    decorate();
    new MutationObserver(schedule).observe(drawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
